import config from '@/config';
import { Storage } from '@/classes/Storage';

export default {
  lang: Storage.get('locale') || config.get('app.i18nLocale', 'de'),
};
